module.exports = __webpack_public_path__ + "img/设备维护.1ec0c80b.png";